import { cn } from "@/lib/utils";

type AuroraOrbProps = {
  className?: string;
  color?: "violet" | "blue" | "magenta" | "cyan";
  size?: number;
  delay?: number;
};

const colorMap = {
  violet: "hsl(var(--aurora-1) / 0.7)",
  blue: "hsl(var(--aurora-2) / 0.7)",
  magenta: "hsl(var(--aurora-3) / 0.7)",
  cyan: "hsl(var(--aurora-4) / 0.7)",
};

export function AuroraOrb({ className, color = "violet", size = 480, delay = 0 }: AuroraOrbProps) {
  return (
    <div
      aria-hidden
      className={cn("aurora-orb", className)}
      style={{
        width: size,
        height: size,
        background: `radial-gradient(circle at 30% 30%, ${colorMap[color]}, transparent 60%)`,
        animationDelay: `${delay}s`,
      }}
    />
  );
}

export function AuroraField({ className }: { className?: string }) {
  return (
    <div aria-hidden className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}>
      <AuroraOrb color="violet" size={620} className="-left-32 -top-32" delay={0} />
      <AuroraOrb color="blue" size={520} className="right-[-8rem] top-20" delay={3} />
      <AuroraOrb color="magenta" size={460} className="left-1/3 bottom-[-10rem]" delay={6} />
      <AuroraOrb color="cyan" size={380} className="right-1/4 bottom-10" delay={9} />
    </div>
  );
}
